import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import PaginationComponent from "../../../Components/biblio/PaginationComponent";
import { useEffect, useState } from "react";
import MyCarsEdit from "./MyCarsEdit";
import { useTranslation } from "react-i18next";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { toGetModel } from "../../../apis/actions/vehicle.actions";
import VehicleLicensePlate from "../../../Components/vehicule/VehicleLicensePlate";
import { resolveVehicleModelDisplayName } from "../../../utils/vehicleDisplay";
import ProfileTabState from "./ProfileTabState";

export const MyCars = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const itemPerPage = 4;
  const { myVehicles, models } = useSelector((state: RootState) => state?.vehicle);
  const [currentPage, setActive] = useState<number>(1);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedData, setSelectedData] = useState<any>(null);

  useEffect(() => {
    dispatch(toGetModel());
  }, [dispatch]);

  const handleOpenModal = (data: any) => {
    setSelectedData(data);
    setShowModal(true);
  };

  const vStatus = myVehicles?.status ?? "idle";
  const mStatus = models?.status ?? "idle";
  const list = myVehicles?.list ?? [];
  const vehiclesTerminal =
    vStatus === "succedded" || vStatus === "rejected";
  const modelsTerminal =
    mStatus === "succedded" || mStatus === "rejected";
  const loading = !(vehiclesTerminal && modelsTerminal);
  const empty =
    vStatus === "succedded" &&
    list.length === 0;

  return (
    <>
      <ProfileTabState loading={loading} empty={empty} emptyKey="cars">
        <div className="pb-50">
          {list
          .slice(itemPerPage * (currentPage - 1), itemPerPage * currentPage)
          .map((el: any) => {
            const modelName = resolveVehicleModelDisplayName(el, models?.list);
            const plateAria = [
              t("profile.car.plate"),
              el?.plate_numbers,
              el?.plate_letters,
            ]
              .filter(Boolean)
              .join(" ");
            return (
              <div
                key={el.id ?? el.vin_sn}
                className="ac-car-info-card"
              >
                <div className="ac-car-info-card__media">
                  <img src={el.image_128} alt="" />
                </div>
                <div className="ac-car-info-card__main">
                  <h3 className="ac-car-info-card__title">{el.title}</h3>
                  <dl className="ac-car-info-card__meta">
                    <div className="ac-car-info-card__meta-row">
                      <dt>{t("profile.car.model")}</dt>
                      <dd>{modelName}</dd>
                    </div>
                    <div className="ac-car-info-card__meta-row">
                      <dt>{t("profile.car.vin")}</dt>
                      <dd dir="ltr">{el.vin_sn}</dd>
                    </div>
                  </dl>
                  <VehicleLicensePlate
                    size="xs"
                    className="ac-car-info-card__plate"
                    plateNumbers={el?.plate_numbers}
                    plateLetters={el?.plate_letters}
                    ariaLabel={plateAria}
                  />
                </div>
                <div className="ac-car-info-card__actions">
                  <span
                    className="btn ac--btn-profil-car ac-car-info-card__edit-btn ac--color-primary-light"
                    onClick={() => handleOpenModal(el)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleOpenModal(el);
                      }
                    }}
                  >
                    {t("profile.car.edit")}
                    {i18n.language === "ar" ? (
                      <IoIosArrowBack />
                    ) : (
                      <IoIosArrowForward />
                    )}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
        {list.length > itemPerPage && (
          <PaginationComponent
            total={list.length}
            itemPerPage={itemPerPage}
            active={currentPage}
            setActive={(nb) => {
              setActive(nb);
            }}
          />
        )}
      </ProfileTabState>

      <MyCarsEdit
        showModal={showModal}
        setShowModal={setShowModal}
        selectedData={selectedData}
      />
    </>
  );
};
export default MyCars;
